export const isNotNull = (input: string | null | undefined) => {
  if (input != null && input != '') return true;
  return false;
};

export const formatDate = (dateString: string): string => {
  let date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${month}/${day}/${year}`;
};
